<template>
    <a :href="href">{{ address }}</a>
</template>

<script>
    export default {
        props: {
            localPart: {
                type: String,
                required: true,
            },
            domain: {
                type: String,
                required: true,
            },
        },
        data() {
            const address = this.localPart + '@' + this.domain;
            return {
                address,
                href: 'mailto:' + address,
            };
        },
    };
</script>
